import { SuggestionInput, SuggestionOutput } from '@allocab/allocab-commons-shared-types';
import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '../services/datastore/queryKeys';
import { driverApi } from '../services/network/Api';

const fetchSuggestions = (searchQuery: string | null) =>
  searchQuery
    ? driverApi.get<SuggestionInput, SuggestionOutput, 'list'>('/suggestion/v1/address', {
        address: searchQuery,
      })
    : null;

export const useFetchSuggestions = (searchQueryParam: string | null) =>
  useQuery(queryKeys.user.fetchSuggestions(searchQueryParam), () => fetchSuggestions(searchQueryParam), {
    keepPreviousData: true,
  });
